import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=3c94614e&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=ts"
export * from "./VideoSection.vue?vue&type=script&lang=ts"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=3c94614e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94614e",
  null
  
)

export default component.exports